import { useEffect, useState } from 'react';

import { logger } from '@belong/logging';

import { IChatProps } from '../ui/Chat';
import { isAttachmentApproved, isAttachmentRejected } from './itemCheckers';

export interface IUseAttachmentMessage extends Pick<IChatProps, 'downloadAttachment'> {
  item: connect.ChatTranscriptItem;
}

export const useAttachmentMessage = ({
  item,
  downloadAttachment
}: IUseAttachmentMessage): {
  url?: string;
  attachmentName?: string;
  isRejected?: boolean;
  shouldRender: boolean;
} => {
  const [url, setUrl] = useState<string>();

  // There will only ever be single attachment for any transcript item
  const attachment = item.Attachments?.[0];

  useEffect(() => {
    const attachmentId = attachment?.AttachmentId;

    if (url || !attachmentId || !isAttachmentApproved(attachment)) {
      return;
    }

    const loadUrl = async (): Promise<void> => {
      try {
        const file = await downloadAttachment(attachmentId);

        if (!file) {
          logger.error('ChatMessageAttachment', `ID: ${attachmentId}`, 'Could not download file');
          return;
        }

        setUrl(URL.createObjectURL(file));
      } catch (error) {
        logger.error('ChatMessageAttachment', `ID: ${attachmentId}`, error);
      }
    };
    loadUrl();
  }, [attachment, downloadAttachment, url]);

  if (!attachment) {
    return {
      shouldRender: false
    };
  }

  return {
    attachmentName: attachment?.AttachmentName,
    isRejected: isAttachmentRejected(attachment),
    shouldRender: true,
    url
  };
};
